import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import { PDFImageProps } from '../../../utils/models';
import { getFileUploadTypes } from '../../../utils/utilities';
import { IMAGE_LIMITS } from '../../../utils/constants';

import toastService from '../../../services/toastService';

const initialData = {
	findingsDescription: '',
	findingsLocation: '',
	findingsImage: [] as PDFImageProps[],
	findingsAdditionalDescription: '',
};

class InspectionFindingsForm extends Form {
	state = {
		data: { ...initialData },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		findingsDescription: Joi.string().min(3).required().label('Description'),
		findingsLocation: Joi.string().min(3).required().label('Location'),
		findingsImage: Joi.array().max(IMAGE_LIMITS.INSPECTION_FINDINGS_IMAGE).optional().label('Image'),
		findingsAdditionalDescription: Joi.string().allow('').optional().label('Additional Description'),
	};

	static propTypes = {
		onSave: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onSave({
			findingsDescription: this.state.data.findingsDescription,
			findingsLocation: this.state.data.findingsLocation,
			findingsImage: this.state.data.findingsImage,
			findingsAdditionalDescription: this.state.data.findingsAdditionalDescription,
		});

		this.setState({ data: { ...initialData } });

		toastService.success('Inspection Finding Added Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderInput({
					type: 'text',
					name: 'findingsDescription',
					placeholder: 'Enter Description e.g TOPSIDE INSPECTION FINDINGS',
					label: 'Description',
				})}

				<div className="my-4 divider"></div>

				{this.renderInput({
					type: 'text',
					name: 'findingsLocation',
					placeholder: 'Enter Location e.g TRESTLE SECTION 1 (Axes 1 - 7)',
					label: 'Location',
				})}

				<div className="my-4 divider"></div>

				{this.renderFileInput({
					max: IMAGE_LIMITS.INSPECTION_FINDINGS_IMAGE,
					multiple: false,
					name: 'findingsImage',
					accept: 'image/*',
					label: 'Image',
					sublabel: 'Upload an image for the inspection findings',
					types: getFileUploadTypes(),
				})}

				<div className="my-4 divider"></div>

				{this.renderTextEditor({
					name: 'findingsAdditionalDescription',
					label: 'Additional Description',
					placeholder: 'Enter any additional description for the inspection findings',
				})}

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Add Inspection Finding')}
				</div>
			</form>
		);
	}
}

export default InspectionFindingsForm;
